"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootSearchSagas = exports.watchResultItemDistrictClickSaga = exports.watchSaveSearchToLocalSaga = void 0;
var effects_1 = require("redux-saga/effects");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var StorageApi_1 = require("@/api/browser/StorageApi");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var WindowApi_1 = require("@/api/browser/WindowApi");
var LoginAction_1 = require("@/pages/common/actions/LoginAction");
var SfilterDistrictAction_1 = require("@/pages/search/actions/sfilter/SfilterDistrictAction");
var SfilterAction_1 = require("@/pages/search/actions/sfilter/SfilterAction");
var SfilterUpdateAction_1 = require("@/pages/search/actions/sfilter/SfilterUpdateAction");
var SaveSearchDialogSaga_1 = require("@/pages/search/sagas/SaveSearchDialogSaga");
var HfilterSaga_1 = require("@/pages/search/sagas/HfilterSaga");
var ResultSaga_1 = require("@/pages/search/sagas/ResultSaga");
var ResultItemSaga_1 = require("@/pages/search/sagas/ResultItemSaga");
var DinfoSaga_1 = require("@/pages/search/sagas/DinfoSaga");
var SaveSearchDialogAction_1 = require("@/pages/search/actions/sfilter/SaveSearchDialogAction");
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var SearchAction_1 = require("@/pages/search/actions/SearchAction");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var SaveSearchApiSaga_1 = require("@/pages/common/sagas/api/SaveSearchApiSaga");
var ResultAction_1 = require("@/pages/search/actions/sfilter/ResultAction");
var ResultItemInfiniteScroll_1 = require("@/pages/search/sagas/ResultItemInfiniteScroll");
var RootSearchMapSaga_1 = require("@/pages/search/sagas/RootSearchMapSaga");
var SearchQueryCallSaga_1 = require("@/pages/search/sagas/SearchQueryCallSaga");
var EnquireSagaCall_1 = require("@/pages/search/sagas/EnquireSagaCall");
var MobilePromoSaga_1 = require("@/pages/common/sagas/MobilePromoSaga");
var SearchQuerySaga_1 = require("@/pages/search/sagas/SearchQuerySaga");
var HfilterAction_1 = require("@/pages/search/actions/HfilterAction");
var HeadingAction_1 = require("@/pages/search/actions/sfilter/HeadingAction");
/**
 * Save searchSet to localStorage in Search Page during Login
 */
var watchSaveSearchToLocal = function () {
    var payload, email;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(LoginAction_1.default.SAVE_SEARCHSET_TO_LOCAL_STORAGE)];
            case 1:
                payload = (_a.sent()).payload;
                email = payload;
                return [4 /*yield*/, effects_1.call(EnquireSagaCall_1.saveSearchSetToLocalStorage, email)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
/**
 * Retain last savedSearchId so next save will update the existing one
 * prevent creating lots of savedSearchSets
 */
var watchSaveSearchSuccess = function () {
    var payload, id;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(SaveSearchDialogAction_1.default.SAVE_SEARCH_SUCCESS)];
            case 1:
                payload = (_a.sent()).payload;
                id = payload;
                return [4 /*yield*/, effects_1.call(WindowApi_1.setSearchSetIdHash, id)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SearchAction_1.default.checkSearchIdUpdate())];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
/**
 * Propagate current searchSet same as searchId in URL hash
 * Should be invoked on domLoaded
 */
var watchCheckSearchIdUpdate = function () {
    var isGuest, searchId, languageCode, searchSetDetailsResponse, searchSets, searchSetDetail;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.take(SearchAction_1.default.CHECK_SERACH_ID_UPDATE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 2:
                isGuest = _a.sent();
                if (isGuest)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.select(WindowApi_1.getSearchId)];
            case 3:
                searchId = _a.sent();
                if (!searchId)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 4:
                languageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(SaveSearchApiSaga_1.getSearchSetDetailApi, searchId, languageCode)];
            case 5:
                searchSetDetailsResponse = _a.sent();
                searchSets = searchSetDetailsResponse.data.searchSets;
                searchSetDetail = searchSets && searchSets.length ? searchSets[0] : null;
                if (!!searchSetDetail) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.call(WindowApi_1.removeAllHash)];
            case 6:
                _a.sent();
                return [2 /*return*/];
            case 7: return [4 /*yield*/, effects_1.put(SearchAction_1.default.onSearchSetUpdated(searchSetDetail))];
            case 8:
                _a.sent();
                return [3 /*break*/, 0];
            case 9: return [2 /*return*/];
        }
    });
};
/**
 * Able to reset price filter when currency changed as price options
 * are different for different currencies, and optionId should be
 * removed
 */
var watchSetCurrencySagaUpdate = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(LayoutAction_1.default.ON_SET_CURRENCY)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.call(StorageApi_1.setCurrencyCookie, payload)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onPriceMinChanged(0))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onPriceMaxChanged(-1))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.call(SearchQueryCallSaga_1.updateAddressBar)];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.globalReload())];
            case 6:
                _a.sent();
                return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
exports.watchSaveSearchToLocalSaga = function () {
    var payload, email;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(LoginAction_1.default.SAVE_SEARCHSET_TO_LOCAL_STORAGE)];
            case 1:
                payload = (_a.sent()).payload;
                email = payload;
                return [4 /*yield*/, effects_1.call(EnquireSagaCall_1.saveSearchSetToLocalStorage, email)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
exports.watchResultItemDistrictClickSaga = function () {
    var payload, districtId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(ResultAction_1.default.ON_RESULT_DISTRICT_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                districtId = payload.districtId;
                return [4 /*yield*/, effects_1.put(SfilterAction_1.default.clearCriteria())];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SfilterDistrictAction_1.default.changeDistrict(districtId, true))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SfilterUpdateAction_1.default.filterUpdateNow())];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchHeadingChangedSaga = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HeadingAction_1.default.SET_HEADING)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.call(WindowApi_1.setTitle, payload)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchInit = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(WindowApi_1.updateSlider)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SearchAction_1.default.checkSearchIdUpdate())];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var searchSagas = {
    watchSaveSearchToLocal: watchSaveSearchToLocal,
    watchSaveSearchSuccess: watchSaveSearchSuccess,
    watchCheckSearchIdUpdate: watchCheckSearchIdUpdate,
    watchInit: watchInit,
    watchSetCurrencySagaUpdate: watchSetCurrencySagaUpdate,
};
var rootSearchSagas = {
    rootPublicPageSagas: __assign(__assign({}, RootPublicPageSaga_1.rootPublicPageSagas), { rootPageSagas: __assign(__assign({}, RootPublicPageSaga_1.rootPublicPageSagas.rootPageSagas), { rootLayoutSagas: __assign(__assign({}, RootPublicPageSaga_1.rootPublicPageSagas.rootPageSagas.rootLayoutSagas), { watchSetCurrency: watchSetCurrencySagaUpdate }) }) }),
    rootSearchMapSagas: RootSearchMapSaga_1.rootSearchMapSagas,
    saveSearchDialogSagas: SaveSearchDialogSaga_1.saveSearchDialogSagas,
    hfilterSagas: HfilterSaga_1.hfilterSagas,
    resultItemSagas: ResultItemSaga_1.resultItemSagas,
    resultItemInfiniteScrollSagas: ResultItemInfiniteScroll_1.resultItemInfiniteScrollSagas,
    resultSagas: ResultSaga_1.resultSagas,
    dinfoSagas: DinfoSaga_1.dinfoSagas,
    searchSagas: searchSagas,
    mobilePromoSagas: MobilePromoSaga_1.mobilePromoSagas,
    watchSaveSearchToLocalSaga: exports.watchSaveSearchToLocalSaga,
    watchSaveSearchSuccess: watchSaveSearchSuccess,
    watchResultItemDistrictClickSaga: exports.watchResultItemDistrictClickSaga,
    searchQuerySagas: SearchQuerySaga_1.searchQuerySagas,
    watchHeadingChangedSaga: watchHeadingChangedSaga,
};
exports.rootSearchSagas = rootSearchSagas;
